/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import ContactOpportunityKanbanBody from "components/CRMComponents/CRMContactDetailsComponents/CRMContactOpportunityComponents/ContactOpportunityKanbanBody/ContactOpportunityKanbanBody";

const CRMContactOpportunityKanban = () => {
  useEffect(() => {
    document.title = "CRM Contact Information | Opportunity";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <ContactOpportunityKanbanBody />
    </main>
  );
};

export default CRMContactOpportunityKanban;
